import { db } from "@/firebaseConfig";

const paymentsCollection = db.collection("payments");

const savePayment = async (id, data) => {
  paymentsCollection
    .doc(id)
    .set(data)
    .then(() => {
      console.log("Payment successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updatePayment = async (id, data) => {
  paymentsCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("Payment successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deletePayment = async id => {
  paymentsCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("Payment successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getPaymentById = async id => {
  return paymentsCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

const getPaymentByRangeOfDates = async (start, end) => {
  return paymentsCollection
    .where("payment_on", ">=", start)
    .where("payment_on", "<=", end)
    .orderBy("payment_on")
    .get()
    .then(querySnapshot => {
      let result = [];
      querySnapshot.forEach(doc => {
        result.push({ id: doc.id, ...doc.data() });
      });

      return result;
    })
    .catch(error => {
      throw error;
    });
};

const getLastPayment = () => {
  return paymentsCollection
    .orderBy("number", "desc")
    .limit(1)
    .get()
    .then(doc => {
      return !doc.empty ? doc.docs[0].data() : null;
    })
    .catch(error => {
      throw error;
    });
};

const getSetOfPayments = () => {
  return paymentsCollection
    .where("payment_on", "!=", null)
    .orderBy("payment_on")
    .limit(50)
    .get()
    .then(doc => {
      console.log("docCurrent", doc);
      return !doc.empty ? doc : null;
    })
    .catch(error => {
      throw error;
    });
};

const getNextSetOfPayments = async last => {
  return paymentsCollection
    .where("payment_on", "!=", null)
    .orderBy("payment_on")
    .startAfter(last.data().payment_on)
    .limit(50)
    .get()
    .then(doc => {
      console.log("docNext", doc);
      return !doc.exists ? doc : null;
    })
    .catch(error => {
      throw error;
    });
};

const getPaymentByDate = async start => {
  return paymentsCollection
    .where("payment_on", ">=", start)
    .orderBy("payment_on")
    .get()
    .then(querySnapshot => {
      let result = [];
      querySnapshot.forEach(doc => {
        result.push({ id: doc.id, ...doc.data() });
      });

      return result;
    })
    .catch(error => {
      throw error;
    });
};

export {
  paymentsCollection,
  savePayment,
  updatePayment,
  deletePayment,
  getPaymentById,
  getPaymentByRangeOfDates,
  getLastPayment,
  getSetOfPayments,
  getNextSetOfPayments,
  getPaymentByDate
};
